/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedProjectRequestDto } from '../../models/backend-patched-project-request-dto';
import { BackendProjectDto } from '../../models/backend-project-dto';

export interface ProjectsProjectsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedProjectRequestDto;
}

export function projectsProjectsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: ProjectsProjectsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProjectDto>> {
  const rb = new RequestBuilder(rootUrl, projectsProjectsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProjectDto>;
    }),
  );
}

projectsProjectsPartialUpdate.PATH = '/api/projects/projects/{id}/';
